export enum Features {
  USER_GENERATED_CONTENT = 'USER_GENERATED_CONTENT',
  RESOURCE_CONTENT = 'RESOURCE_HUB_CONTENT',
  GOOGLE_IDENTITY_SERVICE = 'GOOGLE_IDENTITY_SERVICE'
}
